"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getRelativeFormatter = getRelativeFormatter;
const autoFormatRelative_js_1 = require("../date/autoFormatRelative.js");
const getDifferenceByUnit_js_1 = require("../date/getDifferenceByUnit.js");
function getRelativeFormatter(intlFormatters, translate) {
    return (date, unit = 'auto') => {
        if (date == null)
            return '';
        if (unit === 'auto') {
            return (0, autoFormatRelative_js_1.autoFormatRelative)(date, intlFormatters, translate);
        }
        const differenceValue = (0, getDifferenceByUnit_js_1.getDifferenceByUnit)(date, unit);
        return intlFormatters.formatRelativeTime(differenceValue, unit, {
            numeric: 'auto',
            style: 'long',
        });
    };
}
//# sourceMappingURL=getRelativeFormatter.js.map